<template>
  <div>
    <div v-if="!isLoading" class="text-uppercase mt-4 mx-4">
      <h6
        class="primary-heading mb-0 font-weight-bold mb-4 patcraft-text-underline"
        :data-text="$resourceString['product.detail.recommended.weldrods'].slice(0, 3)"
      >
        {{ $resourceString["product.detail.recommended.weldrods.header"] }}
      </h6>
      <button
        type="button"
        class="wf-modal-button-close btn button-full"
        @click="
          () => {
            hideModal('recommended-weldrods-modal');
          }
        "
      >
        <span
          class="png-icon png-icon-icons-symbols--k-txtclose"
          aria-label="Close modal"
        />
      </button>

      <div class="weldrods-modal-container">
        <div class="row">
          <!-- Left column -->
          <div class="col-md-6" v-if="item.trimColors.length">
            <div
              class="swiper-container"
              id="recommended-accessory-swiper"
              v-wf-swiper="{
                parameters: {
                  initialSlide: initialSlideIndex,
                  allowTouchMove: false,
                  navigation: {
                    nextEl: '.wf-swiper-nav-button-next',
                    prevEl: '.wf-swiper-nav-button-prev',
                  },
                },
                slideChangeEvent: onSlideChange,
              }"
            >
              <!-- MAIN IMAGE -->
              <div class="main-image mb-3 border border-dark">
                <div class="wf-product-quick-view-swatch-slide">
                  <a class="px-0 w-75 cart-item-model-no">
                    <div class="swatch-slide-image">
                      <img
                        class="image"
                        :alt="recommendedAccessory.sellingStyleName"
                        :src="getImgSrc()"
                      />
                    </div>
                  </a>
                </div>
              </div>

              <!-- SWIPER SLIDES -->
              <div class="swiper-wrapper">
                <div
                  class="swiper-slide"
                  v-for="(trimColor, colorIndex) in item.trimColors"
                  :key="colorIndex"
                >
                  <div
                    class="active-color-header position-absolute d-flex flex-column accessoryDescription ml-2"
                  >
                    <div :style="{ fontWeight: 'bold' }">
                      {{ productData.collectionCode.description }} WELDROD
                      {{ recommendedAccessory.accesoryStyleNumber }}
                    </div>
                    <div class="trimColors">
                      {{
                        `${item.trimColors.length} ${
                          item.trimColors.length !== 1 ? "colors" : "color"
                        }`
                      }}
                      -
                      {{ trimColor.colorNumber }}
                    </div>
                  </div>
                </div>
              </div>

              <!-- NAVIGATION + THUMBNAILS -->
              <div
                class="wf-swiper-thumbnails wf-swiper-thumbnails-with-nav-buttons d-none ml-3 mr-3 wf-product-thumbnails-size-small"
              >
                <!-- Prev Button -->
                <button
                  v-if="item.trimColors.length > 1"
                  class="wf-swiper-nav-button wf-swiper-nav-button-prev btn btn-full"
                  type="button"
                  @click="goToPrevColor"
                >
                  <span
                    class="png-icon png-icon-icons-glyph--ko-chevron-left png-size arrow-left mt-1"
                  />
                </button>

                <!-- Thumbnails -->
                <div class="wf-swiper-thumbnails-container">
                  <div
                    class="wf-swiper-thumbnail"
                    v-for="(trimColor, colorIndex) in item.trimColors"
                    :key="colorIndex"
                  >
                    <div
                      class="imageInfo"
                      v-for="imageInfo in trimColor.imagesInfo"
                      :key="imageInfo.url"
                    >
                      <a
                        class="cart-item-model-no"
                        @click="onThumbnailClick(trimColor.colorNumber)"
                      >
                        <div class="red-underline" />
                        <img class="image-thumbnail" alt="" :src="imageInfo.url" />
                      </a>
                    </div>
                  </div>
                </div>

                <!-- Next Button -->
                <button
                  v-if="item.trimColors.length > 1"
                  class="wf-swiper-nav-button wf-swiper-nav-button-next btn btn-full"
                  type="button"
                  @click="goToNextColor"
                >
                  <span
                    class="png-icon png-icon-icons-glyph--ko-chevron-right arrow-right png-size mt-1"
                  />
                </button>
              </div>
            </div>
          </div>
          <!-- Right column -->
          <div class="col-md-6">
            <div>
              <strong>
                {{ $resourceString["product.detail.recommended.weldrods.label"] }}
              </strong>
              <ul class="list-unstyled mt-1">
                <li class="weldrods">
                  {{ computedAccessoryLabel }}
                </li>
              </ul>
            </div>
            <div class="d-flex">
              <div class="pr-3">
                <img
                  height="100"
                  :src="
                    $helpers.getColorThumbnailImageUrl(
                      sellingStyleNumber,
                      (pairedMainProductColor || selectedColor).colorNumber
                    )
                  "
                  alt="img"
                />
              </div>
              <div>
                <strong style="display: flex; flex-wrap: wrap; width: 90%">
                  {{
                    $resourceString["product.detail.recommended.weldrods.use.with.label"]
                  }}
                </strong>
                <ul class="list-unstyled mt-1">
                  <li>
                    {{ productData.collectionCode.description }} {{ sellingStyleNumber }}
                  </li>
                  <li>
                    COLOR:
                    {{ (pairedMainProductColor || selectedColor).colorNumber }}
                    {{ (pairedMainProductColor || selectedColor).colorName }}
                  </li>
                </ul>
              </div>
            </div>
            <div class="description-container" v-if="customAccDescription">
              <p
                class="weldrods-description my-3"
                style="font-size: 11.728px; text-transform: none"
                v-html="customAccDescription"
              ></p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="isLoading" class="loader-wrapper">
      <pc-load-more :load-more="() => {}" />
    </div>
    <hr v-if="!isLoading" class="divider shadow m-0" />
    <div v-if="!isLoading" class="d-flex justify-content-end mr-2 mt-2">
      <wf-add-to-cart-button-only
        :selling-style-number="recommendedAccessory.accesoryStyleNumber"
        :color-number="currentColorNumber"
        :is-button="true"
        :quantity="1"
        :save-for-later="false"
        :disabled="!isSampleAvailable"
        cssClasses="btn btn-primary add-to-cart-mobile-button w-auto px-2 py-2"
        @item-added-to-cart="hideModal('recommended-weldrods-modal')"
      >
      </wf-add-to-cart-button-only>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import WFAddToCartButtonOnly from "../wf-add-to-cart-button-only.vue";
import PatcraftApi from "../../../scripts/patcraft-api";
import PcLoadMore from "../common/pc-loading-more.vue";
export default {
  data() {
    return {
      item: {
        trimColors: [],
        sellingStyleNumber: "",
      },
      currentColorNumber: null,
      customAccDescription: "",
      currentColorIndex: 0,
      isLoading: true,
      pairedMainProductColor: null,
    };
  },
  props: ["recommendedAccessory"],
  components: {
    "wf-add-to-cart-button-only": WFAddToCartButtonOnly,
    "pc-load-more": PcLoadMore,
  },
  computed: {
    ...mapGetters({
      selectedColor: "productDetail/color",
      sellingStyleNumber: "productDetail/sellingStyleNumber",
      productData: "productDetail/productData",
    }),
    isSampleAvailable() {
      const currentTrimColor = this.item.trimColors[this.currentColorIndex];
      return currentTrimColor?.sampleAvailability > 0;
    },
    initialSlideIndex() {
      const index = this.item.trimColors.findIndex(
        (c) => c.colorNumber === this.recommendedAccessory.accesoryColorNumber
      );

      const safeIndex = index !== -1 ? index : 0;
      const matchingColor = this.item.trimColors[safeIndex];

      if (matchingColor) {
        this.currentColorNumber = matchingColor.colorNumber;
        this.currentColorIndex = safeIndex;
      }

      return safeIndex;
    },
    computedAccessoryLabel() {
      const currentTrimColor = this.item.trimColors.find(
        (c) => c.colorNumber === this.currentColorNumber
      );
      if (!currentTrimColor) return "";

      return (
        this.$resourceString["product.detail.recommended.weldrod"] +
        " " +
        this.recommendedAccessory.accesoryStyleNumber +
        " - " +
        (this.pairedMainProductColor || this.selectedColor).colorName +
        " " +
        currentTrimColor.colorNumber
      );
    },
  },
  methods: {
    getNextColorNumber() {
      const nextIndex = this.currentColorIndex + 1;
      return this.item.trimColors[nextIndex]?.colorNumber;
    },
    getPrevColorNumber() {
      const prevIndex = this.currentColorIndex - 1;
      return this.item.trimColors[prevIndex]?.colorNumber;
    },
    goToNextColor() {
      const nextColor = this.getNextColorNumber();
      if (nextColor) {
        this.setCurrentColorNumber(nextColor);
        this.$nextTick(() => {
          const swiper = document.querySelector("#recommended-accessory-swiper")?.swiper;
          swiper?.slideTo(this.currentColorIndex);
        });
      }
    },
    goToPrevColor() {
      const prevColor = this.getPrevColorNumber();
      if (prevColor) {
        this.setCurrentColorNumber(prevColor);
        this.$nextTick(() => {
          const swiper = document.querySelector("#recommended-accessory-swiper")?.swiper;
          swiper?.slideTo(this.currentColorIndex);
        });
      }
    },
    onThumbnailClick(colorNumber) {
      this.setCurrentColorNumber(colorNumber);

      // Force Swiper to recognize and update to the new index
      this.$nextTick(() => {
        const swiper = document.querySelector("#recommended-accessory-swiper")?.swiper;
        if (swiper) {
          swiper.slideTo(this.currentColorIndex);
        }
      });
    },
    async fetchAccessoryColors() {
      this.isLoading = true;
      try {
        const response = await PatcraftApi.getProductColors(
          this.recommendedAccessory.accesoryStyleNumber
        );
        if (response.data) {
          this.item = {
            trimColors: response.data.map((color) => {
              const swatchSample = color.samplesInfo?.find(
                (sample) => sample.type?.toLowerCase() === "swatch"
              );
              const sampleAvailability = swatchSample?.sampleAvailability ?? 0;

              return {
                colorNumber: color.colorNumber,
                colorName: color.colorName,
                imagePath: color.imagesInfo[0]?.url,
                imagesInfo: [{ url: color.imagesInfo[0]?.url }],
                sampleAvailability,
              };
            }),
            sellingStyleNumber: this.recommendedAccessory.accesoryStyleNumber,
          };

          this.currentColorNumber =
            this.recommendedAccessory.accesoryColorNumber ||
            response.data[0]?.colorNumber;
        }
        this.isLoading = false;
      } catch (error) {
        console.error("Error fetching accessory colors:", error);
      } finally {
        if (!this.customAccDescription) return;
        this.isLoading = false;
      }
    },
    async fetchAccessory() {
      try {
        const response = await PatcraftApi.getProduct(
          this.recommendedAccessory.accesoryStyleNumber
        );
        if (response.data) {
          this.customAccDescription = response.data.specificationCustomData.description;
        }
        this.isLoading = false;
      } catch (error) {
        console.error("Error fetching accessory details:", error);
      } finally {
        if (this.item.trimColors.length > 0) {
          this.isLoading = false;
        }
      }
    },
    getImgSrc() {
      return this.$resourceString[
        "product.detail.recommended.weldrods.modal.static.image"
      ];
    },
    setCurrentColorNumber(colorNumber) {
      const index = this.item.trimColors.findIndex((c) => c.colorNumber === colorNumber);

      if (index !== -1) {
        this.currentColorNumber = colorNumber;
        this.currentColorIndex = index;
      }

      const matchedColor = this.productData.colors.find((color) =>
        color.recommendedAccessories?.some(
          (acc) =>
            acc.accesoryStyleNumber === this.recommendedAccessory.accesoryStyleNumber &&
            acc.accesoryColorNumber === colorNumber
        )
      );

      if (matchedColor) {
        this.pairedMainProductColor = matchedColor;
      }
    },
    onSlideChange() {
      const swiper = document.querySelector("#recommended-accessory-swiper")?.swiper;
      if (!swiper) return;

      let activeIndex = swiper.activeIndex;

      if (window.innerWidth <= 1024 && activeIndex > 0) {
        activeIndex -= 1;
      }

      const trimColor = this.item.trimColors[activeIndex];

      if (trimColor) {
        this.setCurrentColorNumber(trimColor.colorNumber);
      }
    },

    hideModal(modalName) {
      this.$modal.hide(modalName);
    },
  },
  created() {
    this.fetchAccessoryColors();
    this.fetchAccessory();
  },
};
</script>
